import React from 'react';
import { Button, ButtonSize, ButtonVariant } from '@benzinga/core-ui';
import i18n from '@benzinga/translate';
import { useTranslation } from 'react-i18next';

interface Props {
  symbol: string;
  size?: ButtonSize;
  onClick?: (event: React.MouseEvent<HTMLElement>, id: string) => void;
  variant?: ButtonVariant;
}

const PerksButton: React.FC<Props> = ({ onClick, symbol, variant }) => {
  const { t } = useTranslation('common', { i18n });
  const handleClick: React.MouseEventHandler<HTMLElement> = event => {
    onClick?.(event, 'Perks Button');
  };
  return (
    <Button
      as="a"
      className="perks-button w-full"
      data-action="Click Perks"
      href={`https://www.tiicker.com/brand/${symbol}/perks?utm_campaign=benzinga-perks-button&utm_medium=benzinga-tiicker-pages&utm_source=benzinga-perks`}
      onClick={handleClick}
      rel="noreferrer nofollow"
      target="_blank"
      variant={variant || 'warning'}
    >
      {t('Buttons.perks')}
    </Button>
  );
};

export default PerksButton;
